import {
  FETCH_PRICEBANNER_LIST_SUCCESS,
  FETCH_PRICEBANNER_LIST_ERROR,
  DELETE_PRICEBANNER_LIST_ERROR,
  UPDATE_PRICEBANNER_LIST_SUCCESS,
  UPDATE_PRICEBANNER_LIST_ERROR,
  DELETE_PRICEBANNER_LIST_SUCCESS,
  UPLOAD_PRICEBANNER_LIST_SUCCESS,
  UPLOAD_PRICEBANNER_LIST_ERROR,
  VALIDATE_PRICEBANNER_PRODUCTS_SUCCESS,
  VALIDATE_PRICEBANNER_PRODUCTS_ERROR,
  ADD_PRODUCTS_TO_LIST_SUCCESS,
  ADD_PRODUCTS_TO_LIST_ERROR,
  DELETE_PRICEBANNER_PRODUCT_SUCCESS,
  DELETE_PRICEBANNER_PRODUCT_ERROR,
  CLEAR_PRICEBANNER_LIST,
} from 'constants/actionTypes'

const DEFAULT_STATE = {
  error: null,
  errorSave: null,
  dataSave: null,
  errorUpload: null,
  dataUpload: null,
  errorValidation: null,
  dataValidation: null,
  list: [],
  metadata: {},
}

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_PRICEBANNER_LIST_SUCCESS:
      return {
        ...state,
        error: null,
        list: action.payload?.data ?? [],
        metadata: action.payload?.metadata ?? {},
      }
    case CLEAR_PRICEBANNER_LIST:
      return {
        ...state,
        list: [],
        metadata: {},
        error: null,
      }
    case FETCH_PRICEBANNER_LIST_ERROR:
    case DELETE_PRICEBANNER_LIST_ERROR:
      return {
        ...state,
        error: action.payload,
      }
    case UPDATE_PRICEBANNER_LIST_SUCCESS:
      return {
        ...state,
        dataSave: action.payload,
        errorSave: null,
      }
    case UPDATE_PRICEBANNER_LIST_ERROR:
      return {
        ...state,
        dataSave: null,
        errorSave: action.payload,
      }
    case DELETE_PRICEBANNER_LIST_SUCCESS:
      return {
        ...state,
        error: null,
      }
    case UPLOAD_PRICEBANNER_LIST_SUCCESS:
      return {
        ...state,
        dataUpload: action.payload,
        errorUpload: null,
      }
    case UPLOAD_PRICEBANNER_LIST_ERROR:
      return {
        ...state,
        errorValidation: action.payload,
      }
    case ADD_PRODUCTS_TO_LIST_SUCCESS:
      return {
        ...state,
        dataValidation: action.payload,
      }
    case ADD_PRODUCTS_TO_LIST_ERROR:
      return {
        ...state,
        errorValidation: action.payload,
      }
    case DELETE_PRICEBANNER_PRODUCT_SUCCESS:
      return {
        ...state,
        error: null,
      }
    case DELETE_PRICEBANNER_PRODUCT_ERROR:
      return {
        ...state,
        error: action.payload,
      }
    case VALIDATE_PRICEBANNER_PRODUCTS_SUCCESS:
      return {
        ...state,
        dataValidation: action.payload,
        errorValidation: null,
      }
    case VALIDATE_PRICEBANNER_PRODUCTS_ERROR:
      return {
        ...state,
        dataValidation: null,
        errorValidation: action.payload,
      }
    default:
      return state
  }
}